import { ReactNode } from "react";

export enum ModalTitleTestIds {
  "MODAL_TITLE" = "MODAL_TITLE",
}

export const ModalTitle = ({ children }: { children: ReactNode }) => {
  return (
    <h2
      className="flex-1 min-w-0 leading-snug"
      data-testid={ModalTitleTestIds.MODAL_TITLE}
    >
      {children}
    </h2>
  );
};
